import Head from "next/head";
import Navbar from "../components/general/Navbar";
import Header from "../components/general/Header";
import HiddenMenu from "../components/general/HiddenMenu";
import Footer from "../components/general/Footer";
import {useState, useEffect} from "react";
import AuthServices from "../services/Auth.services";
import Wysiwyg from "../components/content/Wysiwyg";
import PageContent from "../components/general/PageContent";

export default function Home({navigation, loggedIn, jwtToken, categories, pageData}) {
    const [userInfo, setUserInfo] = useState();

    useEffect(() => {
        if (!jwtToken) {
            return;
        }
        setUserInfo(AuthServices.getUserData(jwtToken));
    }, []);

    return (
        <div className="min-h-screen flex flex-col">
            <Head>
                <title>{pageData.seo?.title}</title>
                <meta name="description" content={pageData.seo?.description ?? ''}/>
                <meta name="image" content={pageData.seo?.image ?? ''}/>
            </Head>

            <header>
                <Navbar items={navigation}/>
                <HiddenMenu loggedIn={loggedIn} role={userInfo?.role}/>
                <Header
                    title={pageData.title}
                    small={true}
                    customStyles="pb-8 lg:pb-20"
                />
            </header>

            <main className="px-4 z-10 bg-white">
                <Wysiwyg content={pageData}/>

                <PageContent pageData={pageData}/>

                {/* <ImageGrid images={gridImages} /> */}
            </main>

            <Footer className="bg-white"/>
        </div>
    );
}

export async function getServerSideProps(context) {
    var loggedIn = context.req.cookies["auth"] ? true : false;

    const jwtToken = context.req.cookies["auth"];

    AuthServices.cookieCheck(jwtToken, context);
    await AuthServices.refreshToken(jwtToken, context);

    const {slug} = context.query;

    let foundResult = true;
    const pageData = await fetch(
        process.env.NEXT_PUBLIC_CRAFT_BASE_URL + "/api/pages/" + slug,
        {
            method: "get",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        }
    ).then((response) => {
        if (!response.ok) {
            foundResult = false;
            return [];
        }

        return response.json();
    });

    if (foundResult === false) {
        return {
            notFound: true,
        };
    }

    return {
        props: {
            loggedIn: loggedIn || false,
            jwtToken: jwtToken || null,
            pageData: pageData || null,
        }, // will be passed to the page component as props
    };
}
